import {
    call,
    takeEvery,
    put,
    all,
    select,
    takeLatest,
    take,
    putResolve,
} from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import { push } from 'connected-react-router';
import _ from 'lodash';
import API from '../common/API';
import * as Actions from '../actions/Auth';
import { APIErrors } from '../common/Constants';
import languageObject from '../translations/messages';

const persistenceAuth = (response) => {
    const cookies = new Cookies();
    if (response) {
        // set token to cookies
        cookies.set('oest', response.token, {
            path: '/',
        });
        // set role to cookies
        cookies.set('osesr', response.role, {
            path: '/',
        });
        // set viewer type to cookies
        cookies.set('osesvt', response.viewer_type, {
            path: '/',
        });
        // set viewer live stream to cookies
        cookies.set('osesvlt', response.viewer_live_stream, {
            path: '/',
        });
        // set organizer type to cookies
        cookies.set('osesot', response.organizer_type, {
            path: '/',
        });
        // set CompanyId to cookies
        cookies.set('osescid', response.company_id, {
            path: '/',
        });
        // set eventName to cookies
        cookies.set('osesen', response.event, {
            path: '/',
        });

        // set has live stream to cookies
        cookies.set('oseslt', response.has_live_stream, {
            path: '/',
        });

        // cookies.set('oesFt', !_.isUndefined(response.freeType) ? response.freeType : '', {
        //     path: '/',
        // });
        cookies.set('oesFs', !_.isUndefined(response.freeSeminar) ? response.freeSeminar : '', {
            path: '/',
        });
        cookies.set('oesFls', !_.isUndefined(response.freeLiveStream) ? response.freeLiveStream : '', {
            path: '/',
        });
        cookies.set('oesFe', !_.isUndefined(response.freeExhibition) ? response.freeExhibition : '', {
            path: '/',
        });
        cookies.set('oesWa', !_.isUndefined(response.isWeakAuth) ? response.isWeakAuth : '', {
            path: '/',
        });
        cookies.set('oseLang', response.language, { path: '/' });
    }
};

function* authorize(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/login/?language=${action.payload.language}`
        : '/api/v1/login/';
    try {
        const response = yield call(
            API.login,
            {
                endpoint,
                body: {
                    ...(action.payload.event_name && { event_name: action.payload.event_name }),
                    ...(action.payload.site && { site: action.payload.site }),
                    email: action.payload.email,
                    uuid: action.payload.uuid,
                },
            },
        );
        persistenceAuth(response);
        yield put(Actions.LoginReceived(response));
    } catch (error) {
        yield put(Actions.LoginReceiveFailure(yield error));
    }
}

export function* reproduceAuthorized() {
    const cookies = new Cookies();
    const token = cookies.get('oest');
    const role = Number(cookies.get('osesr'));
    const viewer_type = cookies.get('osesvt');
    const viewer_live_stream = cookies.get('osesvlt');
    const organizer_type = cookies.get('osesot');
    const company_id = cookies.get('osescid');
    const event = cookies.get('osesen');
    // const freeType = cookies.get('oesFt');
    const freeSeminar = cookies.get('oesFs');
    const freeLiveStream = cookies.get('oesFls');
    const freeExhibition = cookies.get('oesFe');
    const isWeakAuth = cookies.get('oesWa');
    const hasLiveStream = cookies.get('oseslt');
    const language = cookies.get('oseLang');

    if (token) {
        yield putResolve(Actions.LoginReceived({
            token,
            role,
            viewer_type,
            viewer_live_stream,
            organizer_type,
            company_id,
            event,
            // freeType,
            freeSeminar,
            freeLiveStream,
            freeExhibition,
            isWeakAuth,
            hasLiveStream,
            language,
        }));
    } else {
        yield put(Actions.LoginReceiveFailure(API.specifyError(APIErrors.authExpired, languageObject.ja['apiErrors.authExpired'])));
    }
}

function* logout() {
    localStorage.removeItem('businessCardParams');

    const cookies = new Cookies();
    const targetSubAdmin = cookies.get('oesRoleAdmin');
    cookies.remove('oest', { path: '/' });
    cookies.remove('osesvt', { path: '/' });
    cookies.remove('osesvlt', { path: '/' });
    cookies.remove('osesot', { path: '/' });
    cookies.remove('osescid', { path: '/' });
    cookies.remove('osesen', { path: '/' });
    cookies.remove('osesr', { path: '/' });
    // cookies.remove('oesFt', { path: '/' });
    cookies.remove('oesFs', { path: '/' });
    cookies.remove('oesFls', { path: '/' });
    cookies.remove('oesFe', { path: '/' });
    cookies.remove('oesWa', { path: '/' });
    cookies.remove('oesRoleAdmin', { path: '/' });
    const target = window.location.pathname.split('/')[2];

    if (target && (
        target === 'admin'
        || target === `${process.env.REACT_APP_ROOT_PATH_LOGIN_ADMIN}`
        || target === `${process.env.REACT_APP_ROOT_PATH_LOGIN_SUB_ADMIN}`
    )) {
        if (+targetSubAdmin) {
            yield put(push(`/${process.env.REACT_APP_ROOT_PATH_LOGIN_ADMIN}`));
        } else {
            yield put(push(`/${process.env.REACT_APP_ROOT_PATH_LOGIN_SUB_ADMIN}`));
        }
    } else {
        // yield put(push(`/${target}/login`));
    }
    yield put(Actions.LogoutRequestedReceived());
}

function* handleAuthFailures(action) {
    if (action.type.match(/^.+_FAILURE$/)) {
        const errorCode = action.payload && action.payload.errors && action.payload.errors.code;
        if (action.type !== 'LOGIN_REQUESTED_RECEIVED_FAILURE') {
            // eslint-disable-next-line default-case
            switch (errorCode) {
                case APIErrors.authExpired:
                    // case 401 remove cookies and back to home page
                    // maybe show dialog auth expired and click back to login page
                    // yield* logout();
                    yield put(Actions.SetShowDialogAuth(true));
                    break;
                case APIErrors.permissionDenied:
                    yield put(push('/403'));
                    break;
                case APIErrors.server:
                    yield put(push('/404'));
                    break;
            }
        }
    }
}

/**
 * waiting check authorized before call another api need token
 * cavert some case parent task will stop until action LOGIN_RECEIVED dispatch
 */
export function* waitAuthorizedCheck() {
    const credential = yield select((state) => state.auth.credential);

    if (!credential.isAuthorized) {
        yield take('LOGIN_RECEIVED');
        return yield select((state) => state.auth.credential);
    }

    return credential;
}

export function* freeLoginAuthorized(action) {
    try {
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.shortName}/free-login/`,
            },
        );
        // persistenceAuth({ ...response, freeType: action.payload.freeType, isWeakAuth: true });
        persistenceAuth({
            ...response,
            freeSeminar: action.payload.free_seminar,
            freeLiveStream: action.payload.free_live_stream,
            freeExhibition: action.payload.free_exhibition,
            isWeakAuth: true,
        });
        // yield put(Actions.LoginReceived({ ...response, freeType: action.payload.freeType, isWeakAuth: true }));
        yield put(Actions.LoginReceived({
            ...response,
            freeSeminar: action.payload.free_seminar,
            freeLiveStream: action.payload.free_live_stream,
            freeExhibition: action.payload.free_exhibition,
            isWeakAuth: true,
        }));
    } catch (error) {
        yield put(Actions.LoginReceiveFailure(yield error));
    }
}

export default function* auth() {
    yield all([
        takeEvery('LOGIN_REQUESTED', authorize),
        takeEvery('LOGIN_REPRODUCED', reproduceAuthorized),
        takeEvery('*', handleAuthFailures), // * is always running
        takeEvery('WAITING_AUTHORIZED_CHECK', waitAuthorizedCheck),
        takeLatest('LOGOUT_REQUESTED', logout),
        takeLatest('FREE_LOGIN_REQUESTED', freeLoginAuthorized),
    ]);
}
